import type { FC, PropsWithChildren } from "react";

export const IconTile: FC<PropsWithChildren> = props => {
	const {
		children
	} = props;

	return (
		<div className="flex size-8 shrink-0 items-center justify-center rounded-md bg-muted text-muted-foreground [&>svg]:size-4">
			{children}
		</div>
	);
};
